import { get } from '~/services/donationScreen';
import type { AttachmentCategoryOption, TableResponse } from '~/types';
import type { AttachmentCategoriesSetup } from '~/types/setup/setupDataTable';

// module values match Attachments.table / AttachmentCategories.module on the backend (see erp4impact/controllers/setupController/setupAttachmentCategories.py VALID_MODULES)
export const attachmentCategoryModuleOptions: { title: string; value: string }[] = [
  { title: 'Donors', value: 'donors' },
  { title: 'Donations', value: 'donations' },
  { title: 'Grants', value: 'grants' },
  { title: 'Pledges', value: 'pledges' },
  { title: 'Budgets', value: 'budgets' },
  { title: 'Payees', value: 'vendors' },
  { title: 'Advances', value: 'advances' },
  { title: 'Expenses', value: 'expenses' }
];

const moduleLabelMap: Record<string, string> = Object.fromEntries(
  attachmentCategoryModuleOptions.map(option => [option.value, option.title])
);

export const attachmentCategoryModuleLabel = (module: string): string => moduleLabelMap[module] ?? module;

export type AttachmentCategoryEntry = AttachmentCategoryOption & { expenseType: string };

// Fetches every active category for a module, unfiltered by expense type (each entry keeps its own expenseType so FormAttachment.vue can narrow to base + selected type client-side) - powers its `module` prop self-fetch
export const fetchModuleAttachmentCategories = async (module: string): Promise<AttachmentCategoryEntry[]> => {
  try {
    const response = await get<TableResponse<AttachmentCategoriesSetup>>('v1/attachment_categories_list', {
      params: { module, status: 'Active', pageSize: 200 }
    });
    return (response?.data?.data || [])
      .slice()
      .sort((a, b) => a.sort_order - b.sort_order)
      .map(category => ({
        label: category.category_name,
        value: category.category_name,
        required: category.is_mandatory,
        expenseType: category.expense_type
      }));
  } catch (error) {
    console.error('Error fetching attachment categories:', error);
    return [];
  }
};
